/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeasonPassResponse } from './SeasonPassResponse';
import {
    SeasonPassResponseFromJSON,
    SeasonPassResponseFromJSONTyped,
    SeasonPassResponseToJSON,
    SeasonPassResponseToJSONTyped,
} from './SeasonPassResponse';

/**
 * 
 * @export
 * @interface GetSeasonPassesResponse
 */
export interface GetSeasonPassesResponse {
    /**
     * 
     * @type {Array<SeasonPassResponse>}
     * @memberof GetSeasonPassesResponse
     */
    seasonPasses: Array<SeasonPassResponse>;
}

/**
 * Check if a given object implements the GetSeasonPassesResponse interface.
 */
export function instanceOfGetSeasonPassesResponse(value: object): value is GetSeasonPassesResponse {
    if (!('seasonPasses' in value) || value['seasonPasses'] === undefined) return false;
    return true;
}

export function GetSeasonPassesResponseFromJSON(json: any): GetSeasonPassesResponse {
    return GetSeasonPassesResponseFromJSONTyped(json, false);
}

export function GetSeasonPassesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSeasonPassesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'seasonPasses': ((json['seasonPasses'] as Array<any>).map(SeasonPassResponseFromJSON)),
    };
}

export function GetSeasonPassesResponseToJSON(json: any): GetSeasonPassesResponse {
    return GetSeasonPassesResponseToJSONTyped(json, false);
}

export function GetSeasonPassesResponseToJSONTyped(value?: GetSeasonPassesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seasonPasses': ((value['seasonPasses'] as Array<any>).map(SeasonPassResponseToJSON)),
    };
}

